var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedgerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9597A2",
    d: "M35.625 7H19.936v20.986h21.055V12.46C41 9.512 38.583 7 35.625 7ZM15.118 7h-2.631C9.529 7 7 9.401 7 12.469v2.623h8.118V7ZM7 20.005h8.118v8.092H7v-8.092Zm25.882 20.987h2.631c2.958 0 5.487-2.402 5.487-5.47v-2.614h-8.118v8.084Zm-12.945-8.084h8.118V41h-8.119v-8.092ZM7 32.908v2.623C7 38.48 9.409 41 12.487 41h2.631v-8.092H7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerLogo);
export default __webpack_public_path__ + "static/media/ledgerLogo.ef3276b4bdb28da2fe77b8fb381b9072.svg";
export { ForwardRef as ReactComponent };